import { UserPermissionQueryParam, ActionUsingGetParams } from '@servicesTypings/companyRequest'
import { companyRequest, securityRequest, timeOutTimer } from '@/utils/request'
import type { ErpMenu } from './types/getUserMenuPermission'

export const getUserMenuPermission = (params: any): API.Res<ErpMenu> => {
    return securityRequest.get('/security/permission/getUserMenuPermission', { params, timeout: timeOutTimer })
}

export function updateUserMenuPermission(data) {
    return companyRequest.post('/company/permission/updateUserMenuPermission', { data })
}

export function getUserMenuPermissionById(params) {
    return companyRequest.get('/company/permission/getUserMenuPermissionById', { params })
}

// 菜单黑名单
export function queryHidedMenuList(params, headers) {
    return companyRequest.get('/company/permission/hidedMenuList', {
        headers,
        timeout: timeOutTimer,
    })
}

// 校验用户是否有erp菜单权限
/**
 * 查询用户是否有erp菜单权限
 */
export function checkUserHavePermission(data: UserPermissionQueryParam): API.Res<boolean> {
    return companyRequest.post('/company/permission/checkUserHavePermission', { data })
}

// 校验用户是否有erp菜单权限
export function getUserMenus(data) {
    return securityRequest.post('/security/menuConfig/getUserMenus', { data, timeout: timeOutTimer })
}
// 校验用户是否有供应链菜单权限
export function getMenuHasAuthApi(data) {
    return securityRequest.post('/security/menuConfig/judgeMenuHasPower', { data })
}

// 菜单白名单（菜单管理按照版本进行灰度）
/**
 * 查询白名单配置
 */
export function queryUserMenuWhiteList(params: ActionUsingGetParams): API.Res<Record<string, boolean>> {
    return companyRequest.get('/config/allowList/action', { params })
}
